import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, ArrowRight } from "lucide-react";
import { api } from "@/lib/api";
import { Seo } from "@/components/Seo";

const fmtDate = (d) => new Date(d).toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" });

export default function Blog() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/blogs").then((r) => setPosts(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="blog-page">
      <Seo
        title="Blog"
        path="/blog"
        description="Stories, guides and success stories from Ghana's organic farming community — practical advice on organic inputs, cocoa, and sustainable agriculture from Yayra Glover Organic Inputs."
      />
      <section className="bg-brand text-brand-bg noise-overlay">
        <div className="mx-auto max-w-4xl px-6 py-20 text-center">
          <span className="text-xs uppercase tracking-[0.28em] text-brand-ochre font-semibold">Insights & Stories</span>
          <h1 className="mt-4 font-display text-4xl sm:text-5xl">Blog</h1>
          <p className="mt-4 text-brand-bg/80 max-w-xl mx-auto">
            Practical guides, farmer success stories and organic-farming know-how from across Ghana.
          </p>
        </div>
      </section>

      <section className="mx-auto max-w-6xl px-6 py-16">
        {loading ? (
          <div className="py-20 flex justify-center"><Loader2 className="w-8 h-8 animate-spin text-brand" /></div>
        ) : posts.length === 0 ? (
          <p className="text-brand-muted py-16 text-center">No blog posts yet. Check back soon.</p>
        ) : (
          <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3" data-testid="blog-list">
            {posts.map((p) => (
              <Link key={p.blog_id} to={`/blog/${p.slug}`} data-testid={`blog-card-${p.slug}`}
                className="group bg-white border border-brand/10 rounded-sm overflow-hidden flex flex-col hover:shadow-lg transition-shadow">
                {p.cover_image && (
                  <div className="aspect-[16/10] overflow-hidden bg-brand-surface">
                    <img src={p.cover_image} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                  </div>
                )}
                <div className="p-6 flex flex-col flex-1">
                  <p className="text-xs text-brand-muted uppercase tracking-wider">{fmtDate(p.created_at)}</p>
                  <h2 className="mt-2 font-display text-xl text-brand leading-snug group-hover:text-brand-hover transition-colors">{p.title}</h2>
                  <p className="mt-2 text-sm text-brand-muted leading-relaxed line-clamp-3 flex-1">{p.excerpt}</p>
                  <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-medium text-brand-terracotta">
                    Read story <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                  </span>
                </div>
              </Link>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
